import { getPermissionsFromMask } from "Common/permissions";
import map from "lodash/map";
export default (role) => {
    const checkedPermissions = map(getPermissionsFromMask(role.Permissions), "id");
    return {
        ...role,
        CheckedPermissions: checkedPermissions,
        CountPermissions: checkedPermissions.length
    };
};
